import { render, staticRenderFns } from "./MaterialComposition.vue?vue&type=template&id=b9006162&scoped=true"
import script from "./MaterialComposition.vue?vue&type=script&lang=js"
export * from "./MaterialComposition.vue?vue&type=script&lang=js"
import style0 from "./MaterialComposition.vue?vue&type=style&index=0&id=b9006162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9006162",
  null
  
)

export default component.exports